/**
 * Adds the bridge API key header to every request sent to the ProntoBridge.
 *
 * The bridge enforces the key only when BRIDGE_API_KEY is set on its side.
 * When REACT_APP_BRIDGE_API_KEY is empty this interceptor is a no-op, so the
 * admin keeps working against bridges that have no key configured.
 *
 * Import this module for its side effect wherever bridge requests are made
 * (productServices.tsx, BridgeLogs.tsx).
 */
const axios = require("axios");

const { REACT_APP_BRIDGE_URL, REACT_APP_BRIDGE_API_KEY } = process.env;

if (REACT_APP_BRIDGE_API_KEY && REACT_APP_BRIDGE_URL) {
  axios.interceptors.request.use((config) => {
    if (
      config &&
      typeof config.url === "string" &&
      config.url.startsWith(REACT_APP_BRIDGE_URL)
    ) {
      config.headers = config.headers || {};
      config.headers["x-bridge-api-key"] = REACT_APP_BRIDGE_API_KEY;
    }
    return config;
  });
}

export {};
